export function isCustomerEditEnabled(companies) {
  if (!companies || companies.length === 0) return true;
  return !companies.some(
    company =>
      company?.customer_edit_enabled === false ||
      company?.customer_edit_enabled?.portal === false,
  );
}
